import { render, staticRenderFns } from "./sub-form-labelAlign-editor.vue?vue&type=template&id=7fe18c72&scoped=true"
import script from "./sub-form-labelAlign-editor.vue?vue&type=script&lang=js"
export * from "./sub-form-labelAlign-editor.vue?vue&type=script&lang=js"
import style0 from "./sub-form-labelAlign-editor.vue?vue&type=style&index=0&id=7fe18c72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe18c72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe18c72')) {
      api.createRecord('7fe18c72', component.options)
    } else {
      api.reload('7fe18c72', component.options)
    }
    module.hot.accept("./sub-form-labelAlign-editor.vue?vue&type=template&id=7fe18c72&scoped=true", function () {
      api.rerender('7fe18c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-sub-form/sub-form-labelAlign-editor.vue"
export default component.exports